import { ApplicationStatus } from 'types/applications';

import { TranslationKey } from '..';

export const applicantStatusTranslationMap: { [status in ApplicationStatus]: TranslationKey } = {
  active: 'applicants.status.active',
  hired: 'applicants.status.hired',
  rejected: 'applicants.status.rejected',
  retracted: 'applicants.status.retracted',
};
